import React, {useState} from "react";
import {
  Box,
  Text,
  Flex,
  useToast,
  useDisclosure
} from "@chakra-ui/react";

import { ACTIONS, useUser, useUserUpdate} from '../contexts/user-context';
import { ACTIONS as ACTIONS_FAVORITES, cleanInitialFavorites, useFavoritesUpdate} from '../contexts/favorites-context';
import { toastError, toastSuccess, toastWarning} from './toasts';
import { AuthenticateModal } from './modals';
import { getUserFavorites } from '../utils/user-services';

import { authenticateUser, registerUser,} from "../utils/user-services";

export default function Login() {

  const user = useUser();
  const setUser = useUserUpdate();
  const setFavorites = useFavoritesUpdate();
  const [loading, setLoading] = useState(false);  
  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast();
  
  const logout = () => {
    setUser({type: ACTIONS.LOGOUT})
    setFavorites({
      type : ACTIONS_FAVORITES.SET,
      payload: {data: {launches:{}, pads:{}}}
     })	
    toast({...toastWarning, title:'Logged out successfully!'})
  }
  const login  = async (username, password)=> {
    setLoading(true);

    const response = await authenticateUser(username, password);
    const res = await response;
    const data = await res.json();
    if(res.status === 200){
      toast({...toastSuccess, title: "Success", description: `Logged in as ${data.user.name.charAt(0).toUpperCase() + data.user.name.slice(1) }`}) 

      setUser({
        type: ACTIONS.LOGIN,
        payload: {username: data.user.name, favorites: data.user.favorites, authToken: data.user.authToken}
      })
      getFavorites(username)
      setLoading(false);
      onClose(); // close login modal
    } else {
      toast({...toastError, title: "Unauthorized", description: "Incorrect credentials"})  
      setLoading(false);
    }
  }

  const signup = async (username, password) => {
    setLoading(true);
    const response = await registerUser(username, password);
    const res = await response;
    const data = await res.json();
    if(res.status === 200){
        toast({...toastSuccess, title: "User registered!", description: "You can now sign in with your credentials"});
        setLoading(false);
    } else {
        let description = '';
        if(res.status === 409) description = data.message
        else description = 'Our service is currently not working';
        toast({...toastError, title:'Error', description})
        setLoading(false);
    }
  }

  const getFavorites = (username) => {
    if(username !=='guest') {
        getUserFavorites(username).then(async e => {
        const data = await e.json()
        const favorites =  cleanInitialFavorites(data.favorites);
        setFavorites({
          type : ACTIONS_FAVORITES.SET,
          payload: {data: favorites}
        })
      })
    }
  }


  return (    
    <Flex alignItems="center" justifyContent="center">
      <Box mr={5}>  
        {user.username !=='guest' ? 
        <Text>Logged in as <Text fontWeight="semibold" as="em">{user.username.charAt(0).toUpperCase() + user.username.slice(1)}</Text></Text>
        : <Text>Want to save your favorites? Login now!</Text>}
      </Box>   
      <AuthenticateModal 
        isOpen={isOpen} 
        onOpen={onOpen} 
        onClose={onClose}
        isLoggedIn={user.username !=='guest'}
        login={login}
        signUp={signup}
        logout={logout}
        loading={loading}
      />
    
    </Flex>
  );
}
